// Lib
import { constant } from 'lodash/fp';

// Utils
import { prop } from '../../../common/utils/immutableHelper';
import { sortByString } from '../../../common/utils/sortUtil';
import { convertMentionToUser } from './mentionUtils';
import { shareCountComparator } from '../../../common/users/utils/userPropertyUtils';
import { getMentionSortRanking } from './getUserSortRanking';

const rankMentions = (searchValue) => {
    const scorer = getMentionSortRanking(searchValue);

    return (mention) => ({
        ...mention,
        score: scorer(convertMentionToUser(mention)),
    });
};

const userHasScore = (user) => !!user.score;

const scoreComparator = (userA, userB) => userB.score - userA.score;

const getName = prop('name');
const getId = prop('id');
const getIsDisabled = prop('disabled');
const getSharingCurrentBoard = prop('sharingCurrentBoard');

const sortByName = (userA, userB) => {
    const userAIsDisabled = getIsDisabled(userA);
    const userBIsDisabled = getIsDisabled(userB);

    if (userAIsDisabled && !userBIsDisabled) return 1;
    if (userBIsDisabled && !userAIsDisabled) return -1;

    return sortByString(getName, constant(0))(userA, userB);
};

const sortBySharingStatusAndShareCountThenName = (userA, userB) => {
    if (getSharingCurrentBoard(userA) && !getSharingCurrentBoard(userB)) return -1;

    if (getSharingCurrentBoard(userB) && !getSharingCurrentBoard(userA)) return 1;

    const shareCountDelta = shareCountComparator(userA, userB);

    if (shareCountDelta === 0) return sortByName(userA, userB);

    return shareCountDelta;
};

const sortUsersByAssignedAndSharingStatusThenName = (currentlyAssignedUserId) => (userA, userB) => {
    if (currentlyAssignedUserId) {
        if (currentlyAssignedUserId === getId(userA)) return -1;
        if (currentlyAssignedUserId === getId(userB)) return 1;
    }

    return sortBySharingStatusAndShareCountThenName(userA, userB);
};

const createSuggestionSortAndFilter = (sorter) => (searchValue, possibleSuggestions) => {
    const filteredSuggestions = searchValue
        ? possibleSuggestions.map(rankMentions(searchValue)).filter(userHasScore).sort(scoreComparator)
        : possibleSuggestions.sort(sorter);

    return filteredSuggestions.slice(0, 5);
};

export const filterAndSortMentionSuggestions = (searchValue, possibleSuggestions) => {
    const sorter = sortBySharingStatusAndShareCountThenName;
    return createSuggestionSortAndFilter(sorter)(searchValue, possibleSuggestions);
};

export const filterAndSortAssignmentSuggestions = (searchValue, currentlyAssignedUserId, possibleSuggestions) => {
    const sorter = sortUsersByAssignedAndSharingStatusThenName(currentlyAssignedUserId);
    return createSuggestionSortAndFilter(sorter)(searchValue, possibleSuggestions);
};
